import './style.scss'
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import utility, { moneyFormat } from "src/utils/utility"
import { PageWrapper, PageTitle, CustomContainer, FlexRow, GridContainer, AppText, Button, AppSpan } from "src/style"
import {ReactComponent as WalletIcon} from 'src/assets/img/wallet-icon.svg'
import { FaArrowUp } from "react-icons/fa";
import { billingHistoryColumns, walletFundingHistoryData, billingHistoryData } from 'src/utils/table-layout'
import helpers from 'src/utils/helpers';
import { Filter, ServerSideTable } from 'src/component';
import { CardDetails, PaymentMethod, TransferAccountDetails, TransferDetails, TxCode } from 'src/popup';
import { useNotifier } from "react-pop-notifier"


const Billing: React.FC<any> = () => {
    const navigate = useNavigate()
    const {notifier} = useNotifier()
    const {API, downloadReport} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [billingReportData, setBillingReportData] = useState<any>(null)
    const [billingReport, setBillingReport] = useState<Array<any>|null>(null)
    const [billingConfig, setBillingConfig] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [fundingInput, setFundingInput] = useState({
        type: '', amount: '', nameOnCard: '', expiryMonth: '',
        expiryYear: '', cardNumber: '', cvv: '', txCode: ''
    })
    const [view, setView] = useState('')
    
    const filterDataRef = useRef<any>({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchBillingConfig()
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const fetchPayload = { 
            pageNumber, pageSize, 
            ...filterDataRef.current, 
            filter: {...filterDataRef.current.filter},
            //returnMax: isDownload 
        }
        
        const response = await API.getBillings(fetchPayload)
        //const response = {data: billingHistoryData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, `BILLING_HISTORY_REPORT`)
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setBillingReportData(response)
            setBillingReport(response.data)
        }
    }

    async function handleFetchBillingConfig () {
        const response = await API.getBillingConfiguration()
        if (response) setBillingConfig(response)
    }

    async function handleViewBillingRecord (data: any) {
        await setInfoProperty('selectedBilling', data)
        navigate('/client/billing/billing-details')
    }

    function handleSelectedRow ({ selectedRows }: any) {
        console.log({selectedRows})
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    function handleInput (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) {
        setFundingInput({...fundingInput, [e.target.name]: e.target.value})
    }

    function handlePaymentType (type: string) {
        if (type === 'card') setView('card-details')
        else  setView('transfer-account-details') //setView('bank-transfer-details')
    }

    function handleCardPayment () {
        setView('')
        notifier.show('Card Payment Successful', null, 'success')
    }

    function handleBankTransferPayment () {
        setView('')
        notifier.show('Bank Transfer Successful', null, 'success')
    }

    return (
        <>
            <PageWrapper>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    Billing
                </PageTitle>
                <CustomContainer topMargin="2.5">
                    <FlexRow 
                        justifyContent="space-between" 
                        alignItems="stretch" gap="2"
                        className="billing-wallet-container"
                    >
                        <GridContainer 
                            width="68" sizeUnit="%"  bgColor="#ffffff"
                            minHeight="12.7" radius="0.8"
                            borderColor="#EAECF0" padding="2.5"
                            shadow="0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A"
                        >
                            <FlexRow 
                                justifyContent="space-between" gap="2.5" wrap="wrap"
                            >
                                <FlexRow width="auto" sizeUnit="" gap="2.5">
                                    <WalletIcon className="icon-component" />
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppText fontWeight="500" bottomMargin="1">Wallet Balance</AppText>
                                        { billingConfig?.walletBalance ?
                                            <AppText textSize="3" fontWeight="500" color="#101828">N {moneyFormat(billingConfig?.walletBalance || 0, true)}</AppText>
                                            : <AppText fontWeight="500" color="#101828">Could not fetch balance</AppText>
                                        }
                                    </CustomContainer>
                                </FlexRow>
                                <CustomContainer width="auto" sizeUnit="">
                                    <FlexRow justifyContent="flex-end">
                                        <FlexRow 
                                            width="6.8" height="2.4" radius="1.6"
                                            bgColor="#ECFDF3" padding="1" gap="0.5"
                                            topPadding="0.5" bottomPadding="0.5"
                                            bottomMargin="1.5"
                                        >
                                            <FaArrowUp fill="#12B76A" fontSize='1rem' />
                                            <AppText fontWeight="500" color="#027A48">3.4%</AppText>
                                        </FlexRow>
                                    </FlexRow>
                                    <Button
                                        width='14.3'
                                        height='4' radius='0.8'
                                        hoverColor='#0D968F'
                                        hoverBgColor='#fff' borderColor='#0D968F'
                                        onClick={() => setView('payment-method')}
                                        //onClick={() => notifier.show('This feature is currently not available, kindly fund your wallet on BankOne', 'Information', 'success')}
                                    >
                                        + Fund Wallet
                                    </Button>
                                </CustomContainer>
                            </FlexRow>
                        </GridContainer>

                        <GridContainer
                            width="30" sizeUnit="%" bgColor="#ffffff"
                            minHeight="12.7" radius="0.8"
                            borderColor="#EAECF0" padding="2.5"
                            shadow="0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A"
                        >
                            <FlexRow gap="2.5">
                                <WalletIcon className="icon-component fixed-flex-shape" />
                                <CustomContainer width="auto" sizeUnit="">
                                    <AppText fontWeight="500" bottomMargin="1">Expense GL</AppText>
                                    <AppText textSize="3" fontWeight="500" color="#101828">{billingConfig?.expenseGL}</AppText>
                                </CustomContainer>
                            </FlexRow>
                        </GridContainer>
                    </FlexRow>
                    
                    {/* <CustomContainer
                        padding="2" bgColor="#ffffff" 
                        minHeight="10" topMargin="2"
                        borderColor="#EAECF0" radius="0.8"
                        shadow="0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A"
                    >
                        <AppText 
                            textSize="1.8" fontWeight="500"
                            bottomPadding='2' color="#101828"
                            style={{borderBottom: '1px solid #EAECF0'}}
                        >
                            Wallet Funding History
                        </AppText>
                        {
                            walletFundingHistoryData?.slice(0, 5)?.map((item, index) => {
                                return (
                                    <FlexRow 
                                        justifyContent='space-between' 
                                        gap='2' topPadding='1.5' bottomPadding='1.5'
                                        key={index}
                                        style={{borderBottom: '1px solid #EAECF0'}}
                                    >
                                        <CustomContainer width='auto' sizeUnit=''>
                                            <AppText color='#101828' fontWeight='500'>{item.transactionType}</AppText>
                                            <AppSpan>{item.dateCreated ? helpers.splitDateTime(item.dateCreated)?.slashedDate : null}</AppSpan>
                                        </CustomContainer>
                                        <AppText color="#039855">+ N{utility.koboFormat(item.amount || 0)}</AppText>
                                    </FlexRow>
                                )
                            })
                        }
                        { walletFundingHistoryData?.length > 0 &&
                            <AppText 
                                fontWeight='500' color='#0A756F' 
                                align='right' topMargin='1.5'
                                cursor='pointer'
                                onClick={() => navigate('/client/billing/wallet-funding-history')}
                            >
                                Show more
                            </AppText>
                        }
                    </CustomContainer> */}

                    <CustomContainer topMargin='2'>
                        <AppText 
                            textSize="1.8" fontWeight="500"
                            color="#101828" bottomMargin='2'
                        >
                            Billing History
                        </AppText>
                        <ServerSideTable
                            tableData={billingReport}
                            tableColumns={billingHistoryColumns(handleViewBillingRecord)} 
                            dataFetchMethod={handleFetchReport}
                            totalRows={billingReportData?.totalRecords}
                            customStyle
                            shouldResetPagination={resetPagination}
                            canFilter={() => setView('filter')}
                            canClear={handleClear}
                            onSelectedRow={handleSelectedRow}
                            downloadAction={() => handleFetchReport(1, 10, true)}
                        />
                    </CustomContainer>
                </CustomContainer>
            </PageWrapper>
            { view === 'filter' &&
                <Filter
                    type='billing-history'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                />
            }
            { view === 'payment-method' &&
                <PaymentMethod 
                    close={() => setView('')}
                    onTypeSelection={(type: string) => handlePaymentType(type)}
                />
            }
            { view === 'card-details' &&
                <CardDetails 
                    close={() => setView('payment-method')}
                    fundingInput={fundingInput}
                    setFundingInput={setFundingInput}
                    next={() => setView('code')}
                />
            }
            { view === 'code' &&
                <TxCode 
                    close={() => setView('card-details')}
                    onCodeChange={(code: string) => setFundingInput({...fundingInput, txCode: code})}
                    next={handleCardPayment}
                />
            }
            { view === 'bank-transfer-details' &&
                <TransferDetails 
                    close={() => setView('payment-method')}
                    fundingInput={fundingInput}
                    setFundingInput={setFundingInput}
                    next={() => setView('transfer-account-details')}
                />
            }
            { view === 'transfer-account-details' &&
                <TransferAccountDetails 
                    next={handleBankTransferPayment}
                    close={() => setView('payment-method')}
                />
            }
        </>
    )
}

export default utility.routeData('billing', 'Billing', <Billing/>)